import {InfoCircleTwoTone} from "@ant-design/icons";
import {Tooltip} from "antd";
import React, {FC, memo} from "react";
import css from "./InfoIconWithTooltip.less";

type InfoIconWithTooltipProps = {
    text?: string | React.ReactNode;
    tooltipTitle?: string;
    iconStyle?: React.CSSProperties;
};

const InfoIconWithTooltip: FC<InfoIconWithTooltipProps> = ({
    text,
    tooltipTitle,
    iconStyle,
}) => {
    return (
        <div className={css.container}>
            <Tooltip title={tooltipTitle}>
                <InfoCircleTwoTone className={css.infoIcon} style={iconStyle} />
            </Tooltip>
            {text}
        </div>
    );
};

export default memo(InfoIconWithTooltip);
